import { sdk } from '../sdk';

export interface IncomeType {
  _id: string;
  name: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateIncomeTypeData {
  name: string;
}

export interface UpdateIncomeTypeData {
  name?: string;
  isActive?: boolean;
}

export interface IncomeTypeResponse {
  success: boolean;
  data: IncomeType;
}

export interface IncomeTypesResponse {
  success: boolean;
  data: IncomeType[];
}

export const IncomeTypesAPI = {
  async getAllIncomeTypes(): Promise<IncomeType[]> {
    const response = await sdk.client.get('/api/v1/income-types');
    return response.data || response;
  },

  async getActiveIncomeTypes(): Promise<IncomeType[]> {
    const response = await sdk.client.get('/api/v1/income-types/active');
    return response.data || response;
  },

  async getIncomeTypeById(id: string): Promise<IncomeType> {
    const response = await sdk.client.get(`/api/v1/income-types/${id}`);
    return response.data || response;
  },

  async createIncomeType(data: CreateIncomeTypeData): Promise<IncomeTypeResponse> {
    const response = await sdk.client.post('/api/v1/income-types', data);
    return response.data || response;
  },

  async updateIncomeType(id: string, data: UpdateIncomeTypeData): Promise<IncomeTypeResponse> {
    const response = await sdk.client.put(`/api/v1/income-types/${id}`, data);
    return response.data || response;
  },

  async toggleIncomeTypeStatus(id: string): Promise<IncomeTypeResponse> {
    const response = await sdk.client.patch(`/api/v1/income-types/${id}/toggle-status`);
    return response.data || response;
  },

  async deleteIncomeType(id: string): Promise<{ success: boolean; message: string }> {
    const response = await sdk.client.delete(`/api/v1/income-types/${id}`);
    return response.data || response;
  },
};
